(function () {
  'use strict';
  if (window.AudazDigitalAnalytics) return;

  /* Remote telemetry to app.audazdigital.ai removed.
     Public API preserved as no-ops so blocks that call it don't error.
     A/B variant assignment is kept fully local (localStorage + this
     store's own /cart attributes) so on-page A/B tests still work. */

  function randomHex(len) {
    var out = '';
    try {
      var bytes = new Uint8Array(len / 2);
      crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) out += (bytes[i] + 256).toString(16).slice(1);
    } catch (e) {
      while (out.length < len) out += Math.random().toString(16).slice(2);
    }
    return out.slice(0, len);
  }

  function visitorId() {
    try {
      var vid = localStorage.getItem('_audazdigital_vid');
      if (!vid || !/^[a-f0-9]{8,32}$/.test(vid)) {
        vid = randomHex(16);
        localStorage.setItem('_audazdigital_vid', vid);
      }
      return vid;
    } catch (e) {
      return randomHex(16);
    }
  }

  var vid = visitorId();

  function noop() {}

  function sessionOnce(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  function abAssignments() {
    try {
      var parsed = JSON.parse(localStorage.getItem('_audazdigital_ab') || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function abAssign(testId, splitPercentA) {
    var assignments = abAssignments();
    var current = assignments[testId];
    if (current === 1 || current === 2) return current;
    var split = parseInt(splitPercentA, 10);
    if (!(split >= 0 && split <= 100)) split = 50;
    var variant = Math.random() * 100 < split ? 1 : 2;
    assignments[testId] = variant;
    try {
      localStorage.setItem('_audazdigital_ab', JSON.stringify(assignments));
    } catch (e) {}
    return variant;
  }

  function syncCartAttributes() {
    var assignments = abAssignments();
    var serialized = JSON.stringify(assignments);
    var attrs = { _audazdigital_vid: vid };
    if (Object.keys(assignments).length) attrs._audazdigital_ab = serialized;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (e) {}
  }

  window.AudazDigitalAnalytics = {
    track: noop,
    observe: noop,
    flush: noop,
    sessionOnce: sessionOnce,
    abAssign: abAssign,
    abAssignments: abAssignments,
    syncAbCartAttribute: syncCartAttributes,
    syncCartAttributes: syncCartAttributes,
    vid: vid
  };

  // Drain and neutralize the pre-load queue used by inline block scripts.
  window._audazdigitalQ = { push: noop };

  document.dispatchEvent(new CustomEvent('audazdigital:analytics:ready'));
})();
